import UltMeta, { Meta } from "@/meta/UltMeta/index";

/**
 * 空船信息创建来源
 */
class EmptyShipInfoOrigin extends UltMeta {
    ADMIN_BACKEND = new Meta(1, "管理后台");
    SHIP_CLOUD = new Meta(2, "链云船务");
}

export const EMPTY_INFO_ORIGIN = new EmptyShipInfoOrigin();

/**
 * 空船发布状态
 */

class EmptyShipState extends UltMeta {
    NORMAL = new Meta(1, "正常");
    EXPIRED = new Meta(2, "已过期");
    WITHDRAWN = new Meta(3, "已撤回");
}

export const EMPTY_SHIP_STATE = new EmptyShipState();

/**
 * 分享功能来源页面
 */

class ShareFromPage extends UltMeta {
    SHIPPING_REQUIREMENT_PLAT = new Meta(1, "船运需求");
    EMPTY_SHIP = new Meta(2, "空船信息");
}

export const SHARE_FROM_PAGE = new ShareFromPage();

/**
 * 分享类型
 */
class ShareType extends UltMeta {
    WX_FRIEND_SHARE = new Meta(1, "微信好友");
    POSTER_SHARE = new Meta(2, "生成海报");
}

export const SHARE_TYPE = new ShareType();

class ExistDevice extends UltMeta {
    YES = new Meta(1, "已安装");
    NO = new Meta(0, "未安装");
}

export const EXIST_DEVICE = new ExistDevice();
